<template>
	<!-- width="600px" 或者  width="60%"   -->
	<el-dialog
  :close-on-click-modal="false"
  title="添加转交单"
  :show-close="true"
  :visible="true" :modal="false"
		:before-close="handleBeforeClose"
    width="625px">
		<div class="dialog__container">
			<el-form inline ref="form" class="search-form" label-position="right" :model="form" :rules="rules"
				label-width="70px">
        <el-form-item label="标题：" class="input-with-col2 mr0">
        	<el-input size="mini" :rows="4" v-model.trim="form.title" placeholder="请输入标题"
        		clearable></el-input>
        </el-form-item>
				<el-form-item label="接收人员：" prop="toUserId" class="mr0">
					<el-select size="mini" v-model="form.toUserId" filterable placeholder="请选择接收人员" clearable
						reserve-keyword :remote="true" :remote-method="getUserSimpleListFun"
						@visible-change="getUserSimpleListFun('')" value-key="userId">
						<el-option v-for="item in peopleList" :key="item.userId" :label="item.nickname"
							:value="item.userId"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="备注：" class="input-with-col2 mr0">
					<el-input size="mini" type="textarea" :rows="4" v-model.trim="form.remark" placeholder="请输入备注"
						clearable></el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
			<el-button class="plr28" type="primary" size="mini" :loading="loadBtn" @click="handleConfirm">确定</el-button>
		</span>
		<el-dialog :visible.sync="dialogVisible" :modal="false">
			<img width="100%" :src="dialogImageUrl" alt="" />
		</el-dialog>
	</el-dialog>

</template>

<script>
import { saveData, getUserSimpleList } from "@/api/salesManagement/transferOrder"
import cookies from "@/libs/util.cookies";
export default {
	data() {
		return {
			fileList: [],
			form: {
				remark: '',
				projectId: null,
				toUserId: null,
        saleTelemarketingPlanId: null

			},
			headersObj: {
				Authorization: "Bearer " + cookies.get("token"),
				appCode: "YHGHT",
			},
			rules: {
        title: [
        	{
        		required: true,
        		message: "请输入标题",
        		trigger: "change",
        	},
        ],
				toUserId: [
					{
						required: true,
						message: "请选择接收人员",
						trigger: "change",
					},
				],
			},
			loadBtn: false,
			dialogVisible: false,
			dialogImageUrl: '',
			liveImageFileList: [],
			projectList: [],
			peopleList: []
		};
	},
	props: {
		detail: {
			required: true,
			type: Object,
		},
	},
	created() {
		this.getUserSimpleListFun()
		const params = {};
		params.projectId = this.detail.projectId;
		params.saleTelemarketingPlanId = this.detail.planId;
		this.form = { ...params};
		console.log(this.form)
	},
	methods: {
		async getUserSimpleListFun(v = "") {
			this.canSearch = false;
			const res = await getUserSimpleList({ keyword: v, size: 1000 });
			if (res.code === 200) {
				this.peopleList = res.data;
			}
			this.canSearch = true;
		},

		handleBeforeClose(done) {
			this.$emit("cancel");
			done();
		},
		handleCancel() {
			this.$emit("cancel");
		},
		async handleConfirm() {
			if (this.loadBtn) return;
			this.$refs["form"].validate(async (valid) => {
				if (valid) {
					this.loadBtn = true;
          const params = {
            title: this.form.title,
          	projectId: this.form.projectId,
            saleTelemarketingPlanId: this.form.saleTelemarketingPlanId,
          	remark: this.form.remark,
          	toUserId: this.form.toUserId,
            id: this.detail.id
          };

					const res = await saveData(params);
					if (res.code === 200) {
						this.$message.success("编辑成功");
						this.$emit("confirm");
					}
					this.loadBtn = false;
				}
			});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/salesManagement/dxjh/components/AddCause.vue